import React from 'react';
import { Home, X } from 'lucide-react';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';

import styles from 'src/components/errors/ServerError.module.css';

interface ServerErrorProps {
  onDismiss?: () => void;
}

function BrokenHouseIcon() {
    return (
        <div className={`${styles.iconContainer} ${styles.animated}`}>
            <Home size={24} strokeWidth={1.5} />
            <X size={12} strokeWidth={3} className={styles.x} />
        </div>
    );
}

export default function ServerError({ onDismiss }: ServerErrorProps) {
    return (
        <Alert
            severity="error"
            icon={<BrokenHouseIcon />}
            onClose={onDismiss}
            className={styles.alert}
        >
            <Typography variant="body2">
        Oops — something went wrong on our end. Please try again in a moment.
            </Typography>
        </Alert>
    );
}
